import {ScrollableErrorArea, styled} from "@reside/ui";

export const StyledScrollableErrorArea = styled(ScrollableErrorArea)`
  max-height: calc(100vh - 190px);
  overflow: auto;
`;
